/** Resolve which UI surface owns the request; no authentication or backend calls. */
export function getPublicSurface(location = globalThis.location, { pendingGuestQr = false } = {}) {
  const path = String(location?.pathname || '/').replace(/\/+$/, '') || '/';
  const search = new URLSearchParams(location?.search || '');

  // Explicit public routes win over legacy guest query parameters.
  if (path === '/login' || path === '/sign-in') return 'login';
  if (["/find-photographer", "/request-photographer", "/book"].includes(path)) return "inquiry";

  // Historical /?token=... QR links, legacy ?view=... links, and pending
  // QR continuations all remain in the Guest application.
  if (search.has('token') || search.has('view')) return 'guest';
  if ((path === '/' || path === '/index.html') && pendingGuestQr) return 'guest';
  if (path === '/' || path === '/index.html') return 'home';

  // Includes /events/join and /guest; preserve existing guest deep links.
  return 'guest';
}
